import API from "../axiosConfig";

const BASE_URL = "permissions";

export const getAllPermissions = async () => {
  try {
    const response = await API.get(BASE_URL);
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Get permission by ID
 */
export const getPermission = async (id) => {
  try {
    const response = await API.get(`${BASE_URL}/${id}`);
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Create a new permission
 */
export const createPermission = async (permissionData) => {
  try {
    const response = await API.post(BASE_URL, permissionData);
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Update a permission
 */
export const updatePermission = async (id, permissionData) => {
  try {
    const response = await API.put(`${BASE_URL}/${id}`, permissionData);
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Delete a permission
 */
export const deletePermission = async (id) => {
  try {
    const response = await API.delete(`${BASE_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
